var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0396 3L14 4.9604M3 14L3.69507 11.4514C3.74042 11.2851 3.76309 11.202 3.7979 11.1245C3.82881 11.0556 3.86678 10.9902 3.91122 10.9292C3.96126 10.8605 4.02219 10.7996 4.14406 10.6777L10.4247 4.39713C10.5325 4.28931 10.5864 4.23539 10.6486 4.21519C10.7033 4.19742 10.7622 4.19742 10.8168 4.21519C10.879 4.23539 10.9329 4.28931 11.0408 4.39713L12.6029 5.95926C12.7107 6.06709 12.7646 6.121 12.7848 6.18317C12.8026 6.23785 12.8026 6.29676 12.7848 6.35145C12.7646 6.41362 12.7107 6.46753 12.6029 6.57536L6.32229 12.8559C6.20042 12.9778 6.13949 13.0387 6.0708 13.0888C6.00982 13.1332 5.94438 13.1712 5.87554 13.2021C5.79801 13.2369 5.71488 13.2596 5.5486 13.3049L3 14Z",
    stroke: "#020817",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenameIcon);
export default __webpack_public_path__ + "static/media/rename_icon.64918ee6fdeed4181edd7c134cbc54dd.svg";
export { ForwardRef as ReactComponent };